import React from 'react';
import { DsTabs, DsTab, DsIcon } from '@tokenyico/design-system/dist/reactJS';
import { TableView } from 'app/components';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './Orders.less';

export default ({ currentTab, hasRedemption, children }) => {
  const { t } = useTranslation();
  return (
    <TableView id="orders">
      {hasRedemption ? (
        <div className="orders__tabs">
          <DsTabs currentTab={currentTab}>
            <DsTab>
              <NavLink exact to="/orders/subscriptions" style={{ padding: '1rem 1.3rem' }}>
                <DsIcon name="order" size="0.8rem" className="_mright-2" />
                {t('shared.subscriptionOrders')}
              </NavLink>
            </DsTab>

            <DsTab>
              <NavLink exact to="/orders/redemptions" style={{ padding: '1rem 1.3rem' }}>
                <DsIcon name="undo" size="0.8rem" className="_mright-2" />
                {t('shared.redemptionOrders')}
              </NavLink>
            </DsTab>
          </DsTabs>
        </div>
      ) : (
        ''
      )}
      {children}
    </TableView>
  );
};
